// extracted by mini-css-extract-plugin
export default {"tableMetric":"keywordSuggestionTable_tableMetric__oCmz1","progress":"keywordSuggestionTable_progress__I1-RU"};